{
  "adrian_barry": {
    "contestantDetails": {
      "name": "Adrian Barry",
      "twitter": "WhosAdrianBarry"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=nxWLZA5NGFI",
      "yt_title": "A cheater returns from his ban, a hurling howler & the most surprising end in history! | CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 14,
        "Losses": 94
      },
      {
        "TimePeriod": "2018",
        "Wins": 5,
        "Losses": 16
      },
      {
        "TimePeriod": "2019",
        "Wins": 1,
        "Losses": 13
      },
      {
        "TimePeriod": "2020",
        "Wins": 6,
        "Losses": 5
      },
      {
        "TimePeriod": "2021",
        "Wins": 1,
        "Losses": 28
      },
      {
        "TimePeriod": "2022",
        "Wins": 1,
        "Losses": 22
      },
      {
        "TimePeriod": "2023",
        "Wins": 0,
        "Losses": 10
      }
    ],
    "showDate": "Oct 28th, 2022",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/nxWLZA5NGFI/hqdefault.jpg"
  },
  "aidan_delaney": {
    "contestantDetails": {
      "name": "Aidan Delaney",
      "twitter": "aidand472"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=QEGac2MFm6A",
      "yt_title": "'Is it just all sad territory for me?' | A debut, controversy & an irate Nathan Murphy | CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 1,
        "Losses": 0
      },
      {
        "TimePeriod": "2023",
        "Wins": 1,
        "Losses": 0
      }
    ],
    "showDate": "Jun 9th, 2023",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/QEGac2MFm6A/hqdefault.jpg"
  },
  "arthur_james_o_dea": {
    "contestantDetails": {
      "name": "Arthur James O'Dea",
      "twitter": "ArthurJamesOD"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=nZswWl_TUTw",
      "yt_title": "'That's pathetic, Mick... what a sad little life' | A new round causes pure chaos! | THE CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 12,
        "Losses": 8
      },
      {
        "TimePeriod": "2022",
        "Wins": 2,
        "Losses": 1
      },
      {
        "TimePeriod": "2023",
        "Wins": 10,
        "Losses": 7
      }
    ],
    "showDate": "Jan 19th, 2024",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/nZswWl_TUTw/hqdefault.jpg"
  },
  "cameron_hill": {
    "contestantDetails": {
      "name": "Cameron Hill",
      "twitter": "CameronHill18"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=y6CGm9YR6wE",
      "yt_title": "Six Nations world cup ties, lucky guesses and a dramatic finish! | THE CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 2,
        "Losses": 15
      },
      {
        "TimePeriod": "2022",
        "Wins": 2,
        "Losses": 3
      },
      {
        "TimePeriod": "2023",
        "Wins": 0,
        "Losses": 12
      }
    ],
    "showDate": "Feb 9th, 2024",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/y6CGm9YR6wE/hqdefault.jpg"
  },
  "dave_mcintyre": {
    "contestantDetails": {
      "name": "Dave McIntyre",
      "twitter": "DaveMcIntyreIRL"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=oEvwAbmfQT0",
      "yt_title": "The Crappy Quiz | October 26th"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 4,
        "Losses": 11
      },
      {
        "TimePeriod": "2018",
        "Wins": 4,
        "Losses": 11
      }
    ],
    "showDate": "Oct 26th, 2018",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/oEvwAbmfQT0/hqdefault.jpg"
  },
  "eoin_sheahan": {
    "contestantDetails": {
      "name": "Eoin Sheahan",
      "twitter": "EoinSheahan"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=7LBDVwNvkMk",
      "yt_title": "CRAPPY QUIZ | Eoin marks his last appearance on the quiz by coming on as a contestant!"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 1,
        "Losses": 0
      },
      {
        "TimePeriod": "2022",
        "Wins": 1,
        "Losses": 0
      }
    ],
    "showDate": "Aug 26th, 2022",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/7LBDVwNvkMk/hqdefault.jpg"
  },
  "ger_gilroy": {
    "contestantDetails": {
      "name": "Ger Gilroy",
      "twitter": "gergilroy"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=mMkemAEb7Q4",
      "yt_title": "Remember, you asked for this! | The Crappy Quiz Returns"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 10,
        "Losses": 31
      },
      {
        "TimePeriod": "2018",
        "Wins": 1,
        "Losses": 2
      },
      {
        "TimePeriod": "2019",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2020",
        "Wins": 3,
        "Losses": 7
      },
      {
        "TimePeriod": "2021",
        "Wins": 3,
        "Losses": 13
      },
      {
        "TimePeriod": "2022",
        "Wins": 3,
        "Losses": 8
      }
    ],
    "showDate": "May 19th, 2023",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/mMkemAEb7Q4/hqdefault.jpg"
  },
  "john_duggan": {
    "contestantDetails": {
      "name": "John Duggan",
      "twitter": "JohnDugganSport"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=NP_d6Oh0dFc",
      "yt_title": "Crappy Quiz | Bruce Springsteen and the BEST nicknames in the world | OTB AM"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 4,
        "Losses": 3
      },
      {
        "TimePeriod": "2019",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2021",
        "Wins": 2,
        "Losses": 0
      },
      {
        "TimePeriod": "2022",
        "Wins": 2,
        "Losses": 2
      }
    ],
    "showDate": "May 27th, 2022",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/NP_d6Oh0dFc/hqdefault.jpg"
  },
  "mick_mccarthy": {
    "contestantDetails": {
      "name": "Mick McCarthy",
      "twitter": "McCarthyMick"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=jHYqOhdMQvU",
      "yt_title": "The wrath of the quizmaster comes for Mick McCarthy | THE CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 6,
        "Losses": 5
      },
      {
        "TimePeriod": "2022",
        "Wins": 5,
        "Losses": 2
      },
      {
        "TimePeriod": "2023",
        "Wins": 1,
        "Losses": 3
      }
    ],
    "showDate": "Jan 12th, 2024",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/jHYqOhdMQvU/hqdefault.jpg"
  },
  "nathan_murphy": {
    "contestantDetails": {
      "name": "Nathan Murphy",
      "twitter": "nathanmurf"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=EBMg4F7dkIs",
      "yt_title": "The Washington....Nationals? | The Quiz Comes Down to the Wire! | THE CRAPPY QUIZ"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 40,
        "Losses": 47
      },
      {
        "TimePeriod": "2018",
        "Wins": 8,
        "Losses": 10
      },
      {
        "TimePeriod": "2019",
        "Wins": 6,
        "Losses": 7
      },
      {
        "TimePeriod": "2020",
        "Wins": 4,
        "Losses": 6
      },
      {
        "TimePeriod": "2021",
        "Wins": 13,
        "Losses": 7
      },
      {
        "TimePeriod": "2022",
        "Wins": 5,
        "Losses": 10
      },
      {
        "TimePeriod": "2023",
        "Wins": 4,
        "Losses": 7
      }
    ],
    "showDate": "Jan 26th, 2024",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/EBMg4F7dkIs/hqdefault.jpg"
  },
  "neil_treacy": {
    "contestantDetails": {
      "name": "Neil Treacy",
      "twitter": "neil_treacy"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=p2Fjq3vVuHk",
      "yt_title": "The Crappy Quiz | July 26th | Can Enda hold his bottle?"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 3,
        "Losses": 6
      },
      {
        "TimePeriod": "2018",
        "Wins": 1,
        "Losses": 1
      },
      {
        "TimePeriod": "2019",
        "Wins": 2,
        "Losses": 3
      },
      {
        "TimePeriod": "2021",
        "Wins": 0,
        "Losses": 2
      }
    ],
    "showDate": "Jul 26th, 2019",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/p2Fjq3vVuHk/hqdefault.jpg"
  },
  "phil_egan": {
    "contestantDetails": {
      "name": "Phil Egan",
      "twitter": "philegansport"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=3YENYyL6fcY",
      "yt_title": "Crappy Quiz | Quizmaster challenged in Friday face-off"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 23,
        "Losses": 17
      },
      {
        "TimePeriod": "2018",
        "Wins": 2,
        "Losses": 4
      },
      {
        "TimePeriod": "2019",
        "Wins": 9,
        "Losses": 5
      },
      {
        "TimePeriod": "2020",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2021",
        "Wins": 10,
        "Losses": 3
      },
      {
        "TimePeriod": "2022",
        "Wins": 2,
        "Losses": 4
      }
    ],
    "showDate": "Mar 11th, 2022",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/3YENYyL6fcY/hqdefault.jpg"
  },
  "ronan_mullen": {
    "contestantDetails": {
      "name": "Ronan Mullen",
      "twitter": "RonanReigns"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=m1x2GyTTPBo",
      "yt_title": "̷T̷̶̷H̷̶̷E̷̶̷ ̷̶̷C̷̶̷R̷̶̷A̷̶̷.̷̶̷.̷̶̷.̷̶̷ ̷ HAPPY QUIZ RETURNS | New look quiz, old look cast 🤔📝"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 2,
        "Losses": 2
      },
      {
        "TimePeriod": "2019",
        "Wins": 1,
        "Losses": 1
      },
      {
        "TimePeriod": "2021",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2022",
        "Wins": 1,
        "Losses": 0
      }
    ],
    "showDate": "Sept 2nd, 2022",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/m1x2GyTTPBo/hqdefault.jpg"
  },
  "shane_hannon": {
    "contestantDetails": {
      "name": "Shane Hannon",
      "twitter": "ShaneHannon01"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=AUBo8QjjR_k",
      "yt_title": "The Crappy Quiz of the year... at its crappiest | \"This should have been one of the great quizzes!\""
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 12,
        "Losses": 25
      },
      {
        "TimePeriod": "2021",
        "Wins": 1,
        "Losses": 0
      },
      {
        "TimePeriod": "2022",
        "Wins": 3,
        "Losses": 6
      },
      {
        "TimePeriod": "2023",
        "Wins": 8,
        "Losses": 19
      }
    ],
    "showDate": "Dec 22nd, 2023",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/AUBo8QjjR_k/hqdefault.jpg"
  },
  "shane_stapleton": {
    "contestantDetails": {
      "name": "Shane Stapleton",
      "twitter": "shanesaint"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=ZiQ1gtziK0Y",
      "yt_title": "The Crappy Quiz | June 29th 2018"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 4,
        "Losses": 6
      },
      {
        "TimePeriod": "2018",
        "Wins": 4,
        "Losses": 6
      }
    ],
    "showDate": "Jun 29th, 2018",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/ZiQ1gtziK0Y/hqdefault.jpg"
  },
  "tommy_rooney": {
    "contestantDetails": {
      "name": "Tommy Rooney",
      "twitter": "tomasoruanaidh"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=0Znp9iLaPMk",
      "yt_title": "The Crappy Quiz: A St. Patrick’s Day Special ☘️"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 20,
        "Losses": 53
      },
      {
        "TimePeriod": "2018",
        "Wins": 7,
        "Losses": 10
      },
      {
        "TimePeriod": "2019",
        "Wins": 5,
        "Losses": 12
      },
      {
        "TimePeriod": "2020",
        "Wins": 1,
        "Losses": 8
      },
      {
        "TimePeriod": "2021",
        "Wins": 5,
        "Losses": 14
      },
      {
        "TimePeriod": "2022",
        "Wins": 1,
        "Losses": 5
      },
      {
        "TimePeriod": "2023",
        "Wins": 1,
        "Losses": 4
      }
    ],
    "showDate": "Mar 17th, 2023",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/0Znp9iLaPMk/hqdefault.jpg"
  },
  "will_ocallaghan": {
    "contestantDetails": {
      "name": "Will O'Callaghan",
      "twitter": "willocallaghan"
    },
    "lastWinningShow": {
      "yt_link": "https://www.youtube.com/watch?v=BfvODy21pIo",
      "yt_title": "The Crappy Quiz | Accusations of quiz corruption | The end of a dominant era?"
    },
    "scoresByYearWon": [
      {
        "TimePeriod": "All Time",
        "Wins": 24,
        "Losses": 27
      },
      {
        "TimePeriod": "2018",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2019",
        "Wins": 0,
        "Losses": 1
      },
      {
        "TimePeriod": "2021",
        "Wins": 2,
        "Losses": 2
      },
      {
        "TimePeriod": "2022",
        "Wins": 9,
        "Losses": 7
      },
      {
        "TimePeriod": "2023",
        "Wins": 13,
        "Losses": 16
      }
    ],
    "showDate": "Jan 5th, 2024",
    "ytThumbnailUrl": "https://i.ytimg.com/vi/BfvODy21pIo/hqdefault.jpg"
  }
}
